import React from 'react';
import { Layout } from 'antd';

const { Content } = Layout;

const layoutStyle = {
  backgroundColor: 'transparent',
};

// eslint-disable-next-line react/prop-types
export function PageLayout({ children }) {
  return (
    <Layout style={layoutStyle}>
      <Content className="xchange-page">{children}</Content>
    </Layout>
  );
}
